import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { Toaster } from "@/components/ui/sonner";
import { LanguageProvider } from "@/i18n/LanguageContext";
import { SiteConfigProvider } from "@/context/SiteConfigContext";
import { AuthProvider } from "@/context/AuthContext";
import { ProtectedRoute } from "@/components/ProtectedRoute";
import { Layout } from "@/components/Layout";
import Home from "@/pages/Home";
import Studio from "@/pages/Studio";
import Services from "@/pages/Services";
import Portfolio from "@/pages/Portfolio";
import ProjectDetail from "@/pages/ProjectDetail";
import Mariages from "@/pages/Mariages";
import Evenementiel from "@/pages/Evenementiel";
import Journal from "@/pages/Journal";
import JournalDetail from "@/pages/JournalDetail";
import Contact from "@/pages/Contact";
import Legal from "@/pages/Legal";
import Login from "@/pages/admin/Login";
import Dashboard from "@/pages/admin/Dashboard";

function App() {
  return (
    <div className="App">
      <HelmetProvider>
      <LanguageProvider>
        <SiteConfigProvider>
        <AuthProvider>
          <BrowserRouter>
            <Routes>
              <Route element={<Layout />}>
                <Route path="/" element={<Home />} />
                <Route path="/studio" element={<Studio />} />
                <Route path="/services" element={<Services />} />
                <Route path="/portfolio" element={<Portfolio />} />
                <Route path="/portfolio/:slug" element={<ProjectDetail />} />
                <Route path="/mariages" element={<Mariages />} />
                <Route path="/evenementiel" element={<Evenementiel />} />
                <Route path="/journal" element={<Journal />} />
                <Route path="/journal/:slug" element={<JournalDetail />} />
                <Route path="/contact" element={<Contact />} />
                <Route path="/legal/:type" element={<Legal />} />
              </Route>
              <Route path="/admin/login" element={<Login />} />
              <Route path="/admin" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
            </Routes>
          </BrowserRouter>
          <Toaster position="top-center" richColors />
        </AuthProvider>
        </SiteConfigProvider>
      </LanguageProvider>
      </HelmetProvider>
    </div>
  );
}

export default App;
